import axios from 'axios'
//import qs from 'qs'

const getToken = process.env.VUE_APP_BEAPI_TOKEN ;//'https://drc.api.harrods.com/api/token'; // 'https://api-drc.dev.harrods.com/api/token';

/*
const client = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
   }
})
*/


axios.defaults.withCredentials = true


export default
{ 
  async getAccessToken()
  {
    return axios({
      url: getToken,
      method: 'get',
      timeout: 8000,
      withCredentials: true,
      crossorigin: true
    })
    .then(res => res.data.access_token)
    .catch (err =>{
      console.error(err); 
      throw(err);
    } )
  }
  
}